import * as React from 'react';
import styled from '@independent-software/typeui/styles/Theme'
import { StampedModel } from '../../services/';

import { StampRow } from './StampRow';
import { Icon } from '@independent-software/typeui/controls/Icon'
import { Panel } from '@independent-software/typeui/controls/Panel'
import { Divider } from '@independent-software/typeui/controls/Divider'

interface IProps {
  className?: string;
  model: StampedModel;
}

const TimestampBase = (props: IProps) => {
  const [open, setOpen] = React.useState(false); // Panel currently open?

  const handleClick = () => {
    setOpen(!open);
  }

  const handleClose = () => {
    setOpen(false);
  }

  return (
    <div className={props.className}>
      <Icon color="#888" size="large" name="heart-beat" onClick={handleClick}/>
      <Panel open={open} onClose={handleClose}>
        <StampRow label="Created" user={props.model.created_by} time={props.model.created_at}/>
        {props.model.updated_by && <React.Fragment>
          <Divider fitted/>
          <StampRow label="Updated" user={props.model.updated_by} time={props.model.updated_at}/>
        </React.Fragment>}
        {props.model.deleted_by && <React.Fragment>
          <Divider fitted/>
          <StampRow label="Deleted" user={props.model.deleted_by} time={props.model.deleted_at}/>
        </React.Fragment>}          
      </Panel>
    </div>
  );
}

const Timestamp = styled(TimestampBase)`
  position: relative;
  display: inline-block;  
  margin-left: 10px;
`

export { Timestamp };
